import { StateObservable } from 'redux-observable';
import { map } from 'rxjs/operators';

import { VariablesEditorDialogAction, State } from '../..';
import { Observable } from 'rxjs';
import { EpicDependencies } from '../../dependencies.interface';
import { createSetUseEditableImage } from '../../actions';

export const setUseEditableImageFromApi = (
  _actions$: Observable<VariablesEditorDialogAction>,
  _state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<VariablesEditorDialogAction> => dependencies.useEditableImage$.pipe(map(createSetUseEditableImage));
